import { BASE_URL } from './env'

export const SEO_IMAGE = `${BASE_URL}/assets/share/index.png`
